import { useState, useEffect } from "react";
import { onMessageListener } from "../constants/firebase";
import { motion, AnimatePresence } from "framer-motion";
import { MdClose } from "react-icons/md";
import { useLocation } from "react-router";
import { get } from "firebase/database";
import { getChatId, truncateWords } from "../utils/utils";
import logo from "../assets/images/logo.png";

export default function NotificationToast() {
  const [notification, setNotification] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onMessageListener((payload) => {
      const { title, body } = payload.notification || {};
      const {
        chatId,
        communityId,
        senderId,
        receiverId,
        senderName,
        senderProfilePic,
        type,
      } = payload.data || {};

      // console.log("payload data:", payload.data);

      const pathParts = location.pathname.split("/");

      // 1️⃣ Skip notification if user is on the same private chat
      if (type === "private" && pathParts[1] === "chat") {
        const currentChatId = pathParts[2];
        const currentChat = getChatId(currentChatId, receiverId);
        console.log("currentChat: ", currentChat);
        console.log("chatId: ", chatId);
        if (currentChat && currentChat === chatId) return;
      }

      // 2️⃣ Skip notification if user is on the same community page
      if (type === "community" && pathParts[1] === "community") {
        const currentCommunityId = pathParts[2];
        if (currentCommunityId && currentCommunityId === communityId) return;
      }

      setNotification({ title, body, senderName, senderProfilePic, type });

      setTimeout(() => {
        setNotification(null);
      }, type === "broadcast" ? 6000 : 2000);
    });

    return unsubscribe;
  }, [location.pathname]);

  const handleClose = () => setNotification(null);

  return (
    <AnimatePresence>
      {notification && (
        <motion.div
          initial={{ x: 300, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 300, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed top-5 right-5 z-50 border max-w-sm w-full bg-[#F5F9FE] dark:border-[#F5F9FE] dark:bg-[#242424] text-black dark:text-white border-gray-200 dark:border-0 shadow-lg rounded-lg p-4 flex items-start space-x-3"
        >
          <img
            src={notification.type === "broadcast" ? logo : notification.senderProfilePic}
            alt={notification.type === "broadcast" ? "Zylen" : notification.senderName}
            className={`w-10 h-10 object-cover ${notification.type === "broadcast" ? "rounded-md" : "rounded-full"}`}
          />
          <div className="flex-1 ml-3">
            <p className="text-gray-700 dark:text-white text-xs">
              {notification.type === "broadcast"
                ? "Announcement"
                : notification.type === "community"
                  ? "Community"
                  : notification.type === "group"
                    ? "Group"
                    : "Chat"}
            </p>
            <h4 className="font-semibold text-black dark:text-white">
              {notification.type === "broadcast"
                ? notification.title
                : notification.type === "community" || notification.type === "group"
                  ? notification.title
                  : notification.senderName}
            </h4>
            <p className="text-gray-700 dark:text-white text-sm mt-1 break-words line-clamp-3">
              {truncateWords(notification.body, 18)}
            </p>
          </div>
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <MdClose size={18} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
